var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 756,
    viewBox: "0 0 357 756",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.085 218.174L179.084 248.33C192.098 305.808 228.058 494.97 207.136 756.47H248.358C250.288 702.949 253.931 483.194 197.64 243.751L187.054 218.143L187.085 218.174Z",
    fill: "url(#paint0_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.076 185.743C134.562 182.254 112.27 183.625 91.3478 189.668C90.4449 184.715 88.9193 179.855 86.8022 175.307C84.0624 179.45 81.883 183.967 80.3885 188.702C68.0905 191.039 56.2284 195.556 45.4559 201.943C45.7673 198.422 45.1758 194.809 43.7747 191.537C40.7858 195.525 38.731 200.198 37.8281 205.089C32.0371 205.806 26.6509 209.201 23.5063 214.124C23.2261 211.662 22.9459 209.201 22.6968 206.74C17.404 216.211 9.4648 224.155 0 229.451C4.5456 215.183 11.1772 201.506 20.424 189.762C26.2461 182.378 33.0956 175.743 40.8792 170.509C50.0327 164.341 60.3692 160.135 70.8926 156.833C90.1336 150.789 110.495 147.643 130.515 149.792C144.868 151.35 159.22 155.774 170.616 164.683C182.011 173.562 190.074 187.332 190.043 201.756C190.043 199.482 179.209 193.438 176.936 192.098C170.771 188.391 163.05 186.896 156.014 185.774L156.076 185.743Z",
    fill: "url(#paint1_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6517 87.9845C79.0187 79.8224 109.406 84.7758 134.438 98.5143C143.404 103.437 151.842 109.511 158.318 117.455C165.26 125.96 169.619 136.303 172.639 146.864C176.625 160.852 178.337 175.743 175.317 189.98C175.161 190.759 162.054 183.313 160.964 182.036C158.286 178.89 158.504 176.148 157.508 172.379C154.83 162.098 146.269 153.282 139.295 145.493C124.194 128.639 106.23 114.34 86.4909 103.312C75.376 97.1124 63.7007 91.941 51.6206 87.9534L51.6517 87.9845Z",
    fill: "url(#paint2_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65 71.0683C145.677 58.7004 148.106 45.8653 155.733 36.0832C157.882 37.3605 159.843 38.9493 161.493 40.8185C158.567 32.6252 165.323 24.3385 172.017 18.762C180.578 11.6279 189.888 5.42846 199.788 0.319336C186.401 22.7808 185.249 50.2268 185.311 76.3955C182.82 76.7382 180.361 77.5793 178.181 78.8254C180.579 80.7569 183.225 82.3769 186.027 83.6542C185.529 106.957 188.051 130.322 193.499 153.001C196.675 166.21 200.878 179.513 200.1 193.064C200.006 194.933 199.757 196.896 198.636 198.36C197.017 200.479 193.935 201.071 191.351 200.385C188.767 199.7 186.587 198.018 184.564 196.273C149.942 166.304 141.038 114.683 144.681 71.0994L144.65 71.0683Z",
    fill: "url(#paint3_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.383 91.3803C244.684 62.9997 289.33 50.7253 327.003 64.3704C308.883 69.3861 294.156 82.3147 280.115 94.8694C274.542 99.8539 269 104.807 263.427 109.792C262.15 110.913 260.843 112.097 259.224 112.658C255.176 114.122 250.755 111.443 246.49 111.848C247.268 115.306 248.576 118.639 250.319 121.723C244.871 122.689 239.298 123.125 233.756 123.001C235.811 125.96 238.146 128.702 240.73 131.194C230.518 143.219 220.212 155.338 212.242 168.952C204.272 182.597 198.699 197.987 198.699 213.781C198.699 213.096 182.914 205.339 181.077 201.133C177.839 193.719 179.395 182.441 179.956 174.653C181.388 155.057 186.805 135.68 196.239 118.421C201.656 108.546 208.381 99.3866 216.352 91.4114L216.383 91.3803Z",
    fill: "url(#paint4_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.803 166.616C206.389 162.503 217.846 161.257 229.21 160.79C252.623 159.824 276.347 162.067 298.608 169.482C320.838 176.896 341.574 189.638 356.674 207.582C341.854 207.239 327.003 208.08 312.307 210.074C308.447 210.604 304.493 211.196 300.632 210.573C296.771 209.95 292.911 207.894 291.198 204.404C289.237 207.239 288.023 210.604 287.743 214.031C284.598 215.183 281.329 216.336 277.997 215.962C274.666 215.62 271.304 213.283 270.93 209.95C270.276 212.66 269.622 215.37 268.969 218.049C234.503 212.971 198.854 216.274 165.883 227.582C164.887 227.925 164.264 209.95 164.389 208.485C165.011 201.912 166.755 195.276 169.713 189.357C175.099 178.609 184.751 170.915 195.834 166.616H195.803Z",
    fill: "url(#paint5_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.018 224.217C287.462 241.102 302.095 269.047 304.493 297.832C292.319 289.577 279.336 282.536 265.762 276.804C263.209 275.714 260.531 274.623 258.694 272.505C256.888 270.386 256.297 266.928 258.196 264.903C255.705 266.897 253.184 268.891 250.693 270.885C226.19 251.539 196.239 239.202 165.198 235.744C165.634 235.806 179.302 216.585 182.104 214.466C188.487 209.606 197.453 208.516 205.237 207.862C225.91 206.148 247.143 212.068 263.987 224.186L264.018 224.217Z",
    fill: "url(#paint6_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.432 255.402C167.097 259.109 165.074 263.128 161.649 265.869C158.224 268.611 152.9 269.577 149.631 266.679C152.495 272.91 151.063 280.387 147.919 286.493C144.774 292.599 140.135 297.77 136.15 303.378C128.958 313.534 124.039 325.279 121.797 337.522C119.462 315.278 119.867 292.723 123.011 270.574C124.879 257.302 127.868 243.844 134.998 232.473C142.128 221.102 154.052 212.068 167.44 211.414C178.025 210.915 193.593 217.146 196.737 228.112C185.965 232.753 175.597 245.682 169.432 255.433V255.402Z",
    fill: "url(#paint7_linear_299_47831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.439 194.56C176.967 188.765 167.284 186.46 157.819 186.304C139.824 185.993 122.42 192.815 106.697 201.538C91.1921 210.136 76.5278 220.915 66.3158 235.402C56.3217 249.639 51.1223 266.804 48.6627 284.032C62.8288 264.405 85.1521 252.629 106.697 241.57C108.005 235.059 109.592 228.61 111.523 222.286L117.096 234.374C115.446 230.791 139.575 220.137 142.159 219.295C151.997 216.056 162.552 214.996 172.826 216.305C177.87 216.959 182.82 218.143 187.584 219.95C191.32 221.352 194.776 224.965 196.519 221.507C197.609 219.358 194.838 210.074 194.091 207.862C192.285 202.628 188.798 197.956 184.439 194.591V194.56Z",
    fill: "url(#paint8_linear_299_47831)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_47831",
    x1: 199.882,
    y1: 268.362,
    x2: 229.651,
    y2: 718.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57824D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_299_47831",
    x1: 0.0311342,
    y1: 189.263,
    x2: 190.074,
    y2: 189.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_299_47831",
    x1: 115.228,
    y1: 105.056,
    x2: 113.7,
    y2: 147.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_299_47831",
    x1: 170.833,
    y1: 56.2705,
    x2: 201.659,
    y2: 154.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_299_47831",
    x1: 262.617,
    y1: 89.4799,
    x2: 218.271,
    y2: 173.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_299_47831",
    x1: 328.746,
    y1: 186.678,
    x2: 181.169,
    y2: 195.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_299_47831",
    x1: 267.318,
    y1: 237.084,
    x2: 229.348,
    y2: 267.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_299_47831",
    x1: 120.334,
    y1: 274.436,
    x2: 196.737,
    y2: 274.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_299_47831",
    x1: 48.6627,
    y1: 235.152,
    x2: 196.737,
    y2: 235.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AEC989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#97BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#89B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84B553"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.9f21d4124b991057e21198c535342d97.svg";
export { ForwardRef as ReactComponent };